import React, { useState } from 'react';
import { Review } from '@types';
import ReviewModal from '../components/ReviewModal';

const reviews: Review[] = [
  {
    id: '1',
    name: 'Sarah Chen',
    rating: 5,
    content:
      'Amazing authentic northeastern Chinese cuisine! The iron pot stew was absolutely delicious with perfectly cooked lamb and fresh vegetables. The atmosphere is festive and the staff is incredibly friendly. Highly recommend!',
    source: 'google',
    date: '2 weeks ago',
    avatar: 'S',
  },
  {
    id: '2',
    name: 'Michael Rodriguez',
    rating: 5,
    content:
      'Best iron stew pot in the 626 area! The portions are huge and the flavors are incredible. Love the variety of side dishes that come with each pot. This is now our go-to spot for family dinners.',
    source: 'yelp',
    date: '1 month ago',
    avatar: 'M',
  },
  {
    id: '3',
    name: 'Jennifer Park',
    rating: 5,
    content:
      'The goose pot is phenomenal! Such authentic flavors and the restaurant has beautiful traditional decorations. Service was excellent and they made great recommendations for first-timers. Will definitely be back!',
    source: 'google',
    date: '3 weeks ago',
    avatar: 'J',
  },
  {
    id: '4',
    name: 'David Kim',
    rating: 4,
    content:
      'Great food and generous portions. The lamb spine stew is a must-try! Only wish they had more parking, but the food is worth the short walk. The restaurant has a very warm and welcoming atmosphere.',
    source: 'google',
    date: '1 week ago',
    avatar: 'D',
  },
  {
    id: '5',
    name: 'Lisa Wang',
    rating: 5,
    content:
      'Absolutely love this place! Reminds me of authentic northeastern Chinese cooking. The pickled cabbage with pork is amazing. Staff is very accommodating and helped us order the perfect amount of food. Hidden gem in Hacienda Heights!',
    source: 'yelp',
    date: '2 months ago',
    avatar: 'L',
  },
  {
    id: '6',
    name: 'Robert Lee',
    rating: 5,
    content:
      'The chicken with mushrooms pot is incredible! Perfect for cold evenings. Love that they offer both lunch specials and VIP day deals. Great value for the quality and quantity of food. Definitely coming back with more friends!',
    source: 'google',
    date: '4 days ago',
    avatar: 'R',
  },
];

const ReviewPage: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState<{ name: string; url: string }>({
    name: '',
    url: '',
  });

  const openReviewModal = (platformName: string, platformUrl: string) => {
    setSelectedPlatform({ name: platformName, url: platformUrl });
    setModalOpen(true);
  };

  const renderStars = (rating: number) => {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  return (
    <main>
      <article>
        <section
          className="section review has-bg-image"
          style={{ backgroundImage: "url('/assets/images/hero-slider-2.jpg')" }}
          aria-label="reviews"
          id="review"
        >
          <div className="container">
            <p className="section-subtitle label-2 text-center">Share Your Experience</p>
            <h2 className="headline-1 section-title text-center">Rate Your Experience</h2>

            <div className="review-cards">
              <div className="review-card">
                <div className="review-logo google-logo">G</div>
                <h3 className="review-platform">Google Reviews</h3>
                <p className="review-text">Rate your experience</p>
                <button
                  onClick={() =>
                    openReviewModal(
                      'Google',
                      'https://www.google.com/search?sca_esv=ee794735903e3348&sxsrf=AE3TifNfoaPa0BcoEBTSFSzBuuD57NZ6zA:1761597593488&q=happy+valley+village&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E7Z-1pMAgv0Sr0KRAStbmbMRoYAJALJsGQO1QAHPejvimpM0LL8F6Tf-rqdABuWy2BcL8Sf3jzq_jZB4F-8n5vo7X84pRyQIDKax209347_hGFpvZQ%3D%3D&sa=X&ved=2ahUKEwiE_a-2nsWQAxUal-4BHaF0FPcQrrQLegQIHBAA&biw=1728&bih=992&dpr=2#lrd=0x80c2d5ac2590537d:0xd8705b352115d687,3,,,,'
                    )
                  }
                  className="btn btn-review"
                >
                  <span className="text text-1">Review</span>
                  <span className="text text-2" aria-hidden="true">
                    Review
                  </span>
                </button>
              </div>

              <div className="review-card">
                <div className="review-logo yelp-logo">
                  <svg width="60" height="60" viewBox="0 0 60 60">
                    <g>
                      <path
                        d="M0 30c0-16.57 13.43-30 30-30s30 13.43 30 30c0 16.57-13.43 30-30 30S0 46.57 0 30zm7.5 0c0 12.43 10.07 22.5 22.5 22.5S52.5 42.43 52.5 30c0-12.43-10.07-22.5-22.5-22.5S7.5 17.57 7.5 30z"
                        fill="white"
                      />
                    </g>
                  </svg>
                </div>
                <h3 className="review-platform">Yelp Reviews</h3>
                <p className="review-text">Rate your experience</p>
                <button
                  onClick={() =>
                    openReviewModal(
                      'Yelp',
                      'https://www.yelp.com/writeareview/biz/UkYvxVcqSsToejrjawGjYA?return_url=%2Fbiz%2FUkYvxVcqSsToejrjawGjYA&review_origin=biz-details-war-button'
                    )
                  }
                  className="btn btn-review"
                >
                  <span className="text text-1">Review</span>
                  <span className="text text-2" aria-hidden="true">
                    Review
                  </span>
                </button>
              </div>

              <div className="review-card">
                <div className="review-logo rednote-logo">小红书</div>
                <h3 className="review-platform">RedNote Reviews</h3>
                <p className="review-text">Rate your experience</p>
                <button
                  onClick={() => openReviewModal('RedNote', 'https://xhslink.com/m/3fYunsxhyaU')}
                  className="btn btn-review"
                >
                  <span className="text text-1">Review</span>
                  <span className="text text-2" aria-hidden="true">
                    Review
                  </span>
                </button>
              </div>

              <div className="review-card">
                <div className="review-logo tiktok-logo">
                  <svg
                    width="60"
                    height="60"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
                      fill="white"
                    />
                  </svg>
                </div>
                <h3 className="review-platform">TikTok Reviews</h3>
                <p className="review-text">Rate your experience</p>
                <button
                  onClick={() =>
                    openReviewModal('TikTok', 'https://www.tiktok.com/@shanlitun?_r=1&_t=ZP-917zJwf1jzT')
                  }
                  className="btn btn-review"
                >
                  <span className="text text-1">Review</span>
                  <span className="text text-2" aria-hidden="true">
                    Review
                  </span>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="section customer-reviews" aria-label="customer reviews">
          <div className="container">
            <h2 className="headline-1 section-title text-center customer-reviews-title">
              Customer Reviews
            </h2>

            <div className="reviews-header text-center">
              <div className="overall-rating">
                <span className="rating-number">4.6</span>
                <span className="star-icon">★</span>
              </div>
              <p className="review-count">Based on 150+ reviews</p>
              <div className="source-ratings">
                <span className="source-rating">Google: 4.7★</span>
                <span className="source-rating">Yelp: 4.5★</span>
              </div>
            </div>

            <div className="customer-review-cards">
              {reviews.map((review) => (
                <div key={review.id} className="customer-review-card">
                  <div className="review-avatar">{review.avatar}</div>
                  <h3 className="reviewer-name">{review.name}</h3>
                  <div className="review-stars">{renderStars(review.rating)}</div>
                  <p className="review-content">{review.content}</p>
                  <div className="review-meta">
                    <span className="review-source">
                      {review.source.charAt(0).toUpperCase() + review.source.slice(1)} Reviews
                    </span>
                    <span className="review-time">{review.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section follow-us text-center" aria-label="follow us">
          <div className="container">
            <h2 className="headline-1 section-title">Follow Us</h2>

            <div className="follow-cards">
              <a href="#" className="follow-card">
                <div className="follow-icon">
                  <ion-icon name="camera-outline" aria-hidden="true"></ion-icon>
                </div>
                <p className="follow-name">Instagram</p>
              </a>

              <a href="#" className="follow-card">
                <div className="follow-icon">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 4C13.5 4 5 12.5 5 23C5 33.5 13.5 42 24 42C34.5 42 43 33.5 43 23C43 12.5 34.5 4 24 4ZM24 38C16.3 38 10 31.7 10 24C10 16.3 16.3 10 24 10C31.7 10 38 16.3 38 24C38 31.7 31.7 38 24 38Z"
                      fill="currentColor"
                    />
                    <path
                      d="M24 18C20.7 18 18 20.7 18 24C18 27.3 20.7 30 24 30C27.3 30 30 27.3 30 24C30 20.7 27.3 18 24 18Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <p className="follow-name">Rednote</p>
              </a>

              <a href="https://www.tiktok.com/@shanlitun" target="_blank" rel="noopener noreferrer" className="follow-card">
                <div className="follow-icon">
                  <ion-icon name="musical-notes-outline" aria-hidden="true"></ion-icon>
                </div>
                <p className="follow-name">TikTok</p>
              </a>
            </div>

            <div className="follow-info">
              {[
                { icon: 'chatbubbles-outline', text: '+WeChat' },
                { icon: 'people-outline', text: '+WeChat Group' },
                { icon: 'wifi-outline', text: 'Store WiFi' },
              ].map((item, index) => (
                <a key={index} href="#" className="follow-info-item">
                  <div className="follow-info-icon">
                    <ion-icon name={item.icon} aria-hidden="true"></ion-icon>
                  </div>
                  <span className="follow-info-text">{item.text}</span>
                  <ion-icon name="chevron-down-outline" aria-hidden="true"></ion-icon>
                </a>
              ))}
            </div>
          </div>
        </section>
      </article>

      <ReviewModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        platformName={selectedPlatform.name}
        platformUrl={selectedPlatform.url}
      />
    </main>
  );
};

export default ReviewPage;
